'use client';

import { c as _c } from "react/compiler-runtime";
import { useHits, useInstantSearch, useSearchBox } from 'react-instantsearch';
import { SearchInput } from '@src/components/SearchInput/SearchInput';
import { SearchModalHits } from '@src/components/SearchModal/SearchModalHits';
import { SearchModalRecentSearches } from '@src/components/SearchModal/SearchModalRecentSearches';
import type { HitItem } from '@src/components/SearchModal/types';
import { Spinner } from '@src/components/Spinner/Spinner';
import { useLocalizedRouter } from '@src/hooks/useLocalizedRouter';
import { useRecentSearches } from '@src/hooks/useRecentSearches';
import { useLocale } from '@src/i18n/LocaleProvider';
interface SearchModalContentProps {
  onClose: () => void;
}
export function SearchModalContent(t0) {
  const $ = _c(35);
  const {
    onClose
  } = t0;
  const {
    t
  } = useLocale("search");
  const router = useLocalizedRouter();
  const {
    items
  } = useHits();
  const {
    status
  } = useInstantSearch();
  const {
    query,
    refine
  } = useSearchBox();
  const {
    recentSearches,
    addRecentSearch,
    clearRecentSearches
  } = useRecentSearches();
  let t1;
  if ($[0] !== addRecentSearch || $[1] !== onClose || $[2] !== router) {
    t1 = term => {
      addRecentSearch(term);
      router.push(`/app/search?query=${encodeURIComponent(term)}`);
      onClose();
    };
    $[0] = addRecentSearch;
    $[1] = onClose;
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const goToSearchResults = t1;
  let t2;
  if ($[4] !== goToSearchResults) {
    t2 = suggestion => {
      goToSearchResults(suggestion);
    };
    $[4] = goToSearchResults;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleSuggestionClick = t2;
  let t3;
  if ($[6] !== query) {
    t3 = query.trim();
    $[6] = query;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const hasQuery = !!t3;
  const isSearching = status === "loading" || status === "stalled";
  const isResolved = status === "idle";
  const isLoading = hasQuery && isSearching;
  const showRecent = !isLoading && !hasQuery && recentSearches.length > 0;
  const showHits = !isLoading && isResolved && hasQuery && items.length > 0;
  const showNoResults = !isLoading && isResolved && hasQuery && items.length === 0;
  let t4;
  if ($[8] !== t) {
    t4 = t("placeholder");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== goToSearchResults || $[11] !== refine || $[12] !== t4) {
    t5 = <SearchInput autoFocus={true} onChange={refine} onSubmit={goToSearchResults} placeholder={t4} />;
    $[10] = goToSearchResults;
    $[11] = refine;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== isLoading) {
    t6 = isLoading && <div className="flex justify-center py-4"><Spinner size="large" /></div>;
    $[14] = isLoading;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== clearRecentSearches || $[17] !== handleSuggestionClick || $[18] !== recentSearches || $[19] !== showRecent) {
    t7 = showRecent && <SearchModalRecentSearches recentSearches={recentSearches} handleSuggestionClick={handleSuggestionClick} onClearAll={clearRecentSearches} />;
    $[16] = clearRecentSearches;
    $[17] = handleSuggestionClick;
    $[18] = recentSearches;
    $[19] = showRecent;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== handleSuggestionClick || $[22] !== items || $[23] !== showHits) {
    t8 = showHits && <SearchModalHits items={items} handleSuggestionClick={handleSuggestionClick} />;
    $[21] = handleSuggestionClick;
    $[22] = items;
    $[23] = showHits;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== query || $[26] !== showNoResults || $[27] !== t) {
    t9 = showNoResults && <p className="px-2 py-2.5 text-body-base text-bodi-gray-medium">{t("no-results")} <span className="font-semibold text-bodi-black">{query.trim()}</span></p>;
    $[25] = query;
    $[26] = showNoResults;
    $[27] = t;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t5 || $[30] !== t6 || $[31] !== t7 || $[32] !== t8 || $[33] !== t9) {
    t10 = <div className="flex flex-col gap-8 bg-bodi-white">{t5}{t6}{t7}{t8}{t9}</div>;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  return t10;
}